/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosDownloadButtonFragment, DownloadStepFragment } from "@cosmos/hygraph-schema";

export const getDownloadBtnFromSteps = (steps?: DownloadStepFragment[]): CosmosDownloadButtonFragment | undefined => {
	let downloadBtn = undefined;
	if (!steps) return downloadBtn;
	for (const step of steps) {
		for (const downloadCard of step.content) {
			if (downloadCard.cta?.__typename === "CosmosElementDownloadButton") {
				downloadBtn = downloadCard.cta;
				break;
			}
		}
	}
	return downloadBtn;
};
